import { Audited, Medium } from '@ianesthesie-kit/services';

export enum MedicalDocumentType {
  ECG = 'ECG',
  CARDIAC_TEST = 'CARDIAC_TEST',
  FACE_PICTURE = 'FACE_PICTURE',
  ULTRASOUND = 'ULTRASOUND',
  BLOODWORK = 'BLOODWORK',
  PRESCRIPTION = 'PRESCRIPTION',
  GENETIC_RESULTS = 'GENETIC_RESULTS',
  ECG_SMARTWATCH = 'ECG_SMARTWATCH',
  PACEMAKER_DEFIBRILLATOR_CARD = 'PACEMAKER_DEFIBRILLATOR_CARD',
  OTHER = 'OTHER', // TODO Remove this
  TOBACCO_PRESCRIPTION = 'TOBACCO_PRESCRIPTION',
  TOBACCO_SPECIALIST_REFERRAL = 'TOBACCO_SPECIALIST_REFERRAL',
  UNDER_NUTRITION_PRESCRIPTION = 'UNDER_NUTRITION_PRESCRIPTION',
  UNDER_NUTRITION_SPECIALIST_REFERRAL = 'UNDER_NUTRITION_SPECIALIST_REFERRAL',
  PREOP_LAB_TEST_PRESCRIPTION = 'PREOP_LAB_TEST_PRESCRIPTION',
  ANEMIA_IRON_INJECTION_PRESCRIPTION = 'ANEMIA_IRON_INJECTION_PRESCRIPTION',
  ANEMIA_EPO_INJECTION_PRESCRIPTION = 'ANEMIA_EPO_INJECTION_PRESCRIPTION',
  ANEMIA_EXPERT_REFERRAL = 'ANEMIA_EXPERT_REFERRAL',
  OSA_SPECIALIST_REFERRAL = 'OSA_SPECIALIST_REFERRAL',
  GENERIC_PRESCRIPTION = 'GENERIC_PRESCRIPTION',
  INSURANCE_CARD = 'INSURANCE_CARD',
  INSURANCE_CARD_FRONT = 'INSURANCE_CARD_FRONT',
  INSURANCE_CARD_BACK = 'INSURANCE_CARD_BACK',
  INSURANCE_POLICY = 'INSURANCE_POLICY',
  CONSENT_FORM = 'CONSENT_FORM',
  OPERATOR_INVOICE = 'OPERATOR_INVOICE',
  PAYMENT_RECEIPT = 'PAYMENT_RECEIPT'
}

export const uploadableDocumentTypes = [
  MedicalDocumentType.ECG,
  MedicalDocumentType.CARDIAC_TEST,
  MedicalDocumentType.FACE_PICTURE,
  MedicalDocumentType.ULTRASOUND,
  MedicalDocumentType.BLOODWORK,
  MedicalDocumentType.PRESCRIPTION,
  MedicalDocumentType.GENETIC_RESULTS,
  MedicalDocumentType.ECG_SMARTWATCH,
  MedicalDocumentType.PACEMAKER_DEFIBRILLATOR_CARD,
  MedicalDocumentType.OTHER,
  MedicalDocumentType.INSURANCE_CARD,
  MedicalDocumentType.INSURANCE_CARD_FRONT,
  MedicalDocumentType.INSURANCE_CARD_BACK,
  MedicalDocumentType.INSURANCE_POLICY,
  MedicalDocumentType.OPERATOR_INVOICE
] as const;
export const prescriptionDocumentTypes = [
  MedicalDocumentType.TOBACCO_PRESCRIPTION,
  MedicalDocumentType.TOBACCO_SPECIALIST_REFERRAL,
  MedicalDocumentType.UNDER_NUTRITION_PRESCRIPTION,
  MedicalDocumentType.UNDER_NUTRITION_SPECIALIST_REFERRAL,
  MedicalDocumentType.PREOP_LAB_TEST_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_IRON_INJECTION_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_EPO_INJECTION_PRESCRIPTION,
  MedicalDocumentType.ANEMIA_EXPERT_REFERRAL,
  MedicalDocumentType.OSA_SPECIALIST_REFERRAL,
  MedicalDocumentType.GENERIC_PRESCRIPTION
] as const;

export type PrescriptionDocumentType =
  (typeof prescriptionDocumentTypes)[number];
export type UploadableDocumentType = (typeof prescriptionDocumentTypes)[number];

export interface MedicalDocument extends Audited {
  media: Medium[];
  type: MedicalDocumentType;
  date?: string;
  pending?: boolean;
}

interface PrescriptionMedicalDocument extends MedicalDocument {
  type: PrescriptionDocumentType;
}

export function isPrescription(
  type?: MedicalDocumentType
): type is PrescriptionDocumentType;
export function isPrescription(
  doc?: MedicalDocument
): doc is PrescriptionMedicalDocument;
export function isPrescription(
  doc?: MedicalDocument | MedicalDocumentType
): doc is PrescriptionDocumentType | PrescriptionMedicalDocument {
  return (
    !!doc &&
    prescriptionDocumentTypes.includes(
      (typeof doc === 'string' ? doc : doc.type) as any
    )
  );
}

export type GroupedMedicalDocuments = {
  [k in MedicalDocumentType]?: MedicalDocument[];
};
